var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSs10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 102,
    height: 102,
    transform: "translate(1604 4422)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_toy",
    transform: "translate(-1604 -4422)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "woody-rocking-horse",
    transform: "translate(1604.999 4385.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6225",
    "data-name": "Path 6225",
    d: "M99.233,106.253a4.615,4.615,0,0,0-6.511-.464,46.1,46.1,0,0,1-8.914,5.969c-1.984-4.8-7.375-19.771-4.385-34.638L89.3,83.708a6.611,6.611,0,0,0,10.108-6.987l-3.3-14.288a9.319,9.319,0,0,0-2.493-4.5L92.5,56.817l0-4.1c0-1.179,0-2.357,0-3.241l0-1.373a1.481,1.481,0,0,0-1.474-1.573c-4.468,0-6.677,3.649-7.465,6.326-3.971.283-7.391,2.024-10.679,5.414s-6.4,8.406-9.829,14.113q-.256.427-.519.856H39.583a56.389,56.389,0,0,1-14.226-2.012c-5.051-1.313-14.237-1.233-19,14.045a1.473,1.473,0,0,0,.486,1.589L14.7,93.143a1.473,1.473,0,0,0,2.374-.912c.41-2.5,2.277-9.435,5.934-11.444a4.576,4.576,0,0,1,3.338-.426L16.38,111.668a45.945,45.945,0,0,1-8.741-5.88,4.615,4.615,0,1,0-6.047,6.974c11.617,10.073,29.328,15.851,48.589,15.851s36.97-5.777,48.588-15.849a4.615,4.615,0,0,0,.464-6.51Zm-38.6-30.071c-3.019,4.347-6.754,8.052-12.022,8.052a12.3,12.3,0,0,1-6.379-1.74,9.493,9.493,0,0,1-4.585-6.353q.977.04,1.937.041ZM29.589,79.87a1.473,1.473,0,0,0-.826-1.8,7.871,7.871,0,0,0-7.179.136c-4.011,2.2-6.033,7.895-6.893,11.162L9.476,85.195c1.771-5.208,4.228-8.7,7.31-10.377a10.417,10.417,0,0,1,7.829-.742,65.994,65.994,0,0,0,10.02,1.851A12.306,12.306,0,0,0,40.7,85.014a15.241,15.241,0,0,0,7.906,2.167c9,0,14.189-8.642,16.975-13.284C68.914,68.348,71.92,63.5,75,60.318c3.058-3.154,6.064-4.56,9.744-4.56A1.479,1.479,0,0,0,86.2,54.517a8.771,8.771,0,0,1,1.012-2.7,4.543,4.543,0,0,1,2.347-2.1c0,1.969,0,5.264,0,7.71a1.473,1.473,0,0,0,.431,1.042l1.549,1.549A6.375,6.375,0,0,1,93.245,63.1l3.3,14.288a3.664,3.664,0,0,1-5.6,3.873l-11.66-7.773a1.473,1.473,0,0,0-2.244.861c-4.2,16.445,1.942,33.45,4.092,38.636l-3.866,1.611a40.027,40.027,0,0,0-7.28-9.526,27.858,27.858,0,0,0-39.6,0,40.023,40.023,0,0,0-7.314,9.59q-2.066-.778-4.014-1.674Zm44.886,35.777a78.972,78.972,0,0,1-24.293,3.736,78.971,78.971,0,0,1-24.293-3.736c2.631-4.651,10.428-15.9,24.293-15.9S71.844,111,74.475,115.647ZM97.411,109.4a1.659,1.659,0,0,1-.572,1.143c-11.09,9.615-28.1,15.129-46.658,15.129s-35.57-5.515-46.659-15.13A1.67,1.67,0,0,1,4.5,107.61c.041,0,.081,0,.122,0a1.655,1.655,0,0,1,1.09.408c10.337,8.963,26.963,14.315,44.472,14.315s34.134-5.351,44.471-14.313a1.669,1.669,0,0,1,2.758,1.38Z",
    transform: "translate(0 0)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6226",
    "data-name": "Path 6226",
    d: "M441.486,142.009a1.473,1.473,0,0,0,1.473-1.473v-1.571a1.473,1.473,0,1,0-2.946,0v1.571A1.473,1.473,0,0,0,441.486,142.009Z",
    transform: "translate(-353.597 -73.1)",
    fill: "#f9556d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs10);
export default __webpack_public_path__ + "static/media/ss10.095f3bc36788b4e9fac0355e367e7eee.svg";
export { ForwardRef as ReactComponent };